import {
    Card,
    DataTable,
    EmptyState,
    Page,
    Select,
    Spinner,
    Stack,
    Thumbnail,
} from "@shopify/polaris"
import React, { Component } from "react"
import Preloader from "../../components/Preloader"
import axios from "../../funcs/axios"

export class StatisticProduct extends Component {
    _isMounted = false
    constructor(props) {
        super(props)
        this.state = {
            check: 0,
            listProduct: [],
            loaded: false,
            todosPerPage: 50,
            currentPage: 1,
            todosPerPage: 50,
            rows: [],
            variant: false,
            appWaiting: false,
            selected: "product",
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.loadStaticsProduct()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    loadStaticsProduct = () => {
        let obj = {
            checkVariant: this.state.variant,
        }
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/statistic-product`, obj)
            .then((res) => {
                if (this._isMounted) {
                    this.setState({ listProduct: res.data.result, loaded: true })
                }
                
            })
            .then(() => this.loadAllProduct("descending"))
    }

    handleSelectChange = (val) => {
        this.setState({ selected: val, appWaiting: true })
        if (val == "product") {
            this.setState({ variant: false })
        } else {
            this.setState({ variant: true })
        }
        setTimeout(() => {
            this.loadStaticsProduct()
        }, 0)
    }

    handlePagination(rows) {
        const { currentPage, todosPerPage } = this.state
        // Logic for displaying current todos
        const indexOfLastTodo = currentPage * todosPerPage
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage
        const currentTodos = rows.slice(indexOfFirstTodo, indexOfLastTodo)
        return currentTodos
    }

    sortStatus(rows, index, direction) {
        return [...rows].sort((rowA, rowB) => {
            const amountA = rowA[index]
            const amountB = rowB[index]
            return direction === "descending" ? amountB - amountA : amountA - amountB
        })
    }

    loadAllProduct(direction) {
        let rows = []
        const { listProduct } = this.state
        listProduct.forEach((element) => {
            let array = []
            array.push(<Thumbnail source={element.featured_image} alt={element.title} />)
            array.push(
                <a href={element.uri} target="_blank">
                    {element.title}
                </a>,
            )
            array.push(element.count)
            rows.push(array)
        })
        if (direction == "descending") {
            rows = this.sortStatus(rows, 2, "descending")
        } else {
            rows = this.sortStatus(rows, 2, "ascending")
        }
        this.setState({ rows, appWaiting: false })
        // this.props.parentCallback(true);
    }

    render() {
        const { loaded, rows, selected, appWaiting, listProduct } = this.state
        const options = [
            { label: "Product", value: "product" },
            { label: "Variant", value: "variant" },
        ]
        let data = this.handlePagination(rows)
        return loaded ? (
            <div>
                <Page
                    title={selected == "product" ? "Popular Products" : "Popular Product Variants"}
                >
                    <div style={{ display: "flex", marginBottom: "10px" }}>
                        <div style={{ flex: "2" }}></div>
                        <Select
                            options={options}
                            onChange={(val) => this.handleSelectChange(val)}
                            value={selected}
                        />
                    </div>
                    {listProduct.length ? (
                        <Card>
                            <DataTable
                                columnContentTypes={["text", "text", "text"]}
                                headings={["Image", "Product", "Count"]}
                                rows={data}
                                sortable={[false, false, true]}
                                defaultSortDirection="descending"
                                initialSortColumnIndex={2}
                                onSort={(index, direction) => this.loadAllProduct(direction)}
                            />
                        </Card>
                    ) : (
                        <Card>
                            <Card.Section>
                                <EmptyState
                                    heading="No product in wishlist"
                                    image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                                >
                                    <p>
                                        We couldn't find any result. Please add to wishlist for
                                        product statistics
                                    </p>
                                </EmptyState>
                            </Card.Section>
                        </Card>
                    )}
                </Page>
                {appWaiting ? <Preloader /> : null}
            </div>
        ) : (
            <Stack distribution="center">
                <div style={{ marginTop: "20px", display: "flex" }}>
                    <Spinner
                        accessibilityLabel="Loading more customers"
                        size="large"
                        color="teal"
                    />
                </div>
            </Stack>
        )
    }
}

export default StatisticProduct
